import React, { Component } from 'react';
import '../../css/style.css';
import '../Home.css';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import { translate } from "react-i18next";


class EventNotify extends Component {

    constructor(props) {
        super(props);

        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.onEventInputChange = this.onEventInputChange.bind(this);

        this.state = {
            show: false,
            comment:''
        }
    }

    onEventInputChange(obj) {
        let oldState = this.state;
        
        this.setState({
            ...oldState,
            comment:  obj.target.value
        });

    }



    handleClose() {
        let oldState = this.state;
        this.setState(
            {
                ...oldState,
                show: false
            })
    }

    handleAccept() {
        let oldState = this.state;
        this.props.action(oldState.comment);
        this.setState(
            {
                ...oldState,
                show: false
            })
    }

    handleShow() {
        let oldState = this.state;
        this.setState(
            {
                ...oldState,
                show: true
            })
    }

    render() {
        const { t } = this.props;
        const {   comment } = this.state
        return (<div>
            <Button variant={this.props.variant} onClick={this.handleShow}  size={this.props.size}>
                <i class="far fa-flag s24 mr-2 "></i>
                {this.props.label}
            </Button>

            <Modal show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t(this.props.title)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                    <Col className="mt-1">
                    <Form.Group controlId="bookingStatus">
                        <Form.Label>{t("userComment")}</Form.Label>
                        <Form.Control value={comment}
                            as="textarea"
                            name="comment"
                            placeholder= {t(this.props.text)}
                            onChange={this.onEventInputChange}
                            readOnly={false}
                        />
                        </Form.Group>
                    </Col>
                </Row>
                
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleClose}>
                        {t("cancel")}
                    </Button>
                    <Button variant="primary" onClick={() => this.handleAccept()}>
                        {t(this.props.accept)}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div >
        );
    }


}

export default translate("translations")(EventNotify);